import React, { useState } from 'react'
import Axonslogo from '../../icons/header/axons.svg'
import { CardLogin, CardContainer } from './login.styles'
import { TitlePrimary } from '../../App.styles'
import '../../styleLess/signature/login.scss'
import '../../styleLess/signature/forgot.scss'
import icMail from '../../icons/forgot.svg'
import waitingMail from '../../icons/checkmail-forgot.svg'
import { Button, Form, Input } from 'antd'
import ReCAPTCHA from 'react-google-recaptcha'
import { useHistory } from 'react-router-dom'
import { ACCOUNT_FORGOT_PASSWORD } from 'api/Account/forgotpassword'
import { REACT_APP_GOOGLE_CAPTCHA_KEY } from '../../config/env'

const ForgotComponent = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  // status controller [unauthorization,authorization]
  const [controller, setController] = useState('unauthorization')
  const [valiteer, setValiteer] = useState(false)
  const [recaptcha, setRecaptcha] = useState(String)
  const [delay, setDelay] = useState(true)
  const [email, setEmail] = useState(String)
  const [isLoading, setIsLoading] = useState(false)
  const recaptchaRef = React.useRef()
  function onChange (value) {
    if (value !== null) {
      setRecaptcha(value)
    } else {
      setRecaptcha('')
    }
  }
  const onFinish = (values) => {
    const handleValue = values.email
    setEmail(handleValue)
    const data = {
      email: handleValue,
      recaptcha: recaptcha,
    }
    if (!['', null].includes(recaptcha)) {
      setIsLoading(true)
      try {
        ACCOUNT_FORGOT_PASSWORD({
          params: data,
        }).then((res) => {
          if (res.status === 200) {
            setController('authorization')
            setTimeout(() => {
              setDelay(false)
            }, 100)
            setIsLoading(false)
          } else if (res.errorCode === '2025') {
            setIsLoading(false)
            recaptchaRef.current.reset()
            setRecaptcha(null)
          } else {
            setController('unauthorization')
            recaptchaRef.current.reset()
            setValiteer(true)
            setIsLoading(false)
            setRecaptcha(null)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const ResetManuplatinum = () => {
    setValiteer(false)
  }
  const validateMessages = {
    required: 'Email is required',
    types: {
      email: 'Email is not a valid email',
    },
  }
  const VerifyEmailState = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-forgot-container'>
        <img className='icons-handle' src={icMail} />
        <h2>Forgot your password ?</h2>
        <h4>Enter your registered email below to receive password reset instruction.</h4>
        <Form form={form} onFinish={onFinish} validateMessages={validateMessages}>
          <Form.Item
            className='input-style-forgot'
            name='email'
            rules={[
              {
                type: 'email',
                required: true,
              },
            ]}
          >
            <Input
              className={valiteer === true && 'bd-error'}
              allowClear
              size='large'
              placeholder='Email'
              onChange={ResetManuplatinum}
            />
          </Form.Item>
          {valiteer === true && (
            <p className='msg-error'>* No account found with this email address.</p>
          )}
        </Form>
        <div className='recaptcha-content'>
          <ReCAPTCHA
            ref={recaptchaRef}
            name='recaptcha'
            id='recaptcha'
            sitekey={REACT_APP_GOOGLE_CAPTCHA_KEY}
            onChange={onChange}
            onExpired={() => {
              setRecaptcha('')
              recaptchaRef.current.reset() // here
            }}
            theme='light'
          />
        </div>
        <Button className='BTN_Next' onClick={() => form.submit()} loading={isLoading}>
          Send
        </Button>
        <h4
          className='text-link'
          onClick={() => {
            history.push({
              pathname: '/login',
            })
          }}
        >
          Return to Login
        </h4>
      </div>
    )
  }
  const WaitingMailState = () => {
    return (
      <div className='multi-container-reset-and-forgot wallpaper-forgot-container'>
        <img
          className={delay === true ? 'icons-handle-before' : 'icons-handle'}
          src={waitingMail}
        />
        <h2>Check your email</h2>
        <h4>An email has been sent to</h4>
        <h4 className='weight-font-mail'>{email}</h4>
        <h4>
          It contains a link you must click to <br /> reset your password.
        </h4>

        <h4
          className='text-link text-underline'
          onClick={() => {
            history.push({
              pathname: '/login',
            })
          }}
        >
          Return to Login
        </h4>
      </div>
    )
  }
  return (
    <CardLogin>
      <CardContainer>
        <img
          className='nav-logo'
          src={Axonslogo}
          style={{ width: '55px', height: '55px' }}
        />
        <TitlePrimary className='reponse-iproject-title'>{'AXONS PROJECT'}</TitlePrimary>
        {controller === 'unauthorization' ? VerifyEmailState() : WaitingMailState()}
      </CardContainer>
    </CardLogin>
  )
}

export default ForgotComponent
